import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

const SECTIONS = [
  ["Information we collect", "We collect the information you provide when you create an account, submit cards for grading, or contact us — such as your name, email, shipping address, and card details. We also collect basic technical data (like your browser and IP) to keep the service secure."],
  ["How we use your information", "We use your information to process submissions and payments, grade and return your cards, issue certifications, maintain the population registry, respond to enquiries, and send transactional updates about your orders."],
  ["Payments", "Payments are processed securely by Stripe. We do not store your full card number or CVC on our servers. Stripe's handling of your payment data is governed by their own privacy policy."],
  ["Sharing", "We do not sell your personal information. We share data only with service providers who help us operate (such as payment and email providers), and only as needed to deliver the service, or where required by law."],
  ["Data retention", "We retain submission and certification records to support the permanent, verifiable nature of a MAS certificate and population registry. You may request deletion of your account data, subject to records we are required to keep."],
  ["Your choices", "You can update your account details at any time, opt out of non-essential emails, and contact us to request access to or deletion of your personal data."],
  ["Contact", "Questions about this policy? Email support@mascertified.com."],
];

export default function Privacy() {
  return (
    <div className="bg-white" data-testid="privacy-page">
      <Seo title="Privacy Policy" description="How MAS Grading collects, uses, and protects your information." path="/privacy" />
      <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="How MAS Grading collects, uses, and protects your information." />
      <section className="max-w-3xl mx-auto px-6 lg:px-8 py-20 md:py-28">
        <p className="text-neutral-400 text-sm mb-10">Last updated: June 2026</p>
        <div className="space-y-10">
          {SECTIONS.map(([t, d]) => (
            <div key={t}>
              <h2 className="font-display font-extrabold text-2xl tracking-tight text-[#0A0A0A]">{t}</h2>
              <p className="text-neutral-500 mt-3 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
